const defaultState = {
    id: '',
    imgSrc: ''
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'DRAG_START': {
            return {
                ...state,
                id: action.payload.id,
                imgSrc: action.payload.imgSrc
            };
        }
        case 'DRAG_END': {
            return {
                ...state,
                id: '',
                imgSrc: ''
            };
        }
        default: {
            return state;
        }
    }
}
